import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';
import type { ModeValue } from 'utils/dateUtils';

/**
 * State shared with the custom react-day-picker components (caption, month
 * and year grids, time picker). DayPicker renders them itself, so they can't
 * receive it as props.
 */
export type DatepickerContextValue = {
  selection: ModeValue;
  onDayClick: (date: Date) => void;
  /** Commits a time from the time picker, keeping its date. */
  onTimeChange: (time: Date | undefined) => void;
  onOpenChange: (isOpen: boolean) => void;
  changingMonth: boolean;
  setChangingMonth: Dispatch<SetStateAction<boolean>>;
  changingYear: boolean;
  setChangingYear: Dispatch<SetStateAction<boolean>>;
  /**
   * Offset, in pages of 16 years, from the page that holds the displayed year.
   */
  yearPage: number;
  setYearPage: Dispatch<SetStateAction<number>>;
};

export const DatepickerContext = createContext<
  DatepickerContextValue | undefined
>(undefined);

export const useDatepickerContext = () => {
  const context = useContext(DatepickerContext);
  if (!context) {
    throw new Error('useDatepickerContext must be used within a Datepicker');
  }
  return context;
};
